/* unplugin-vue-components disabled */import { render } from "./ImageBackground.vue?vue&type=template&id=09b54d7a&scoped=true&ts=true"
import script from "./ImageBackground.vue?vue&type=script&lang=ts"
export * from "./ImageBackground.vue?vue&type=script&lang=ts"

import "./ImageBackground.vue?vue&type=style&index=0&id=09b54d7a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09b54d7a"]])

export default __exports__